module.exports = __webpack_public_path__ + "static/media/S2P5_multigene-testing.ddd8dcd3.mp3";